export default {
    landingPages: {
        create: {
            title: 'Create New Landing Page',
            successMessage: 'New Landing Page has been added'
        },
        view: {
            listTitle: 'Watch other meditations from this theme'
        },
        delete: {
            button: 'Delete Landing Page',
            successMessage: 'The Landing Page has been deleted'
        },
        edit: {
            title: 'Edit Landing Page',
            successMessage: 'Landing Page has been updated',
            confirmation: {
                delete: {
                    title: 'Delete Landing Page',
                    description:
                        'Are you sure you want to permanently delete this Landing Page?'
                }
            }
        },
        list: {
            title: 'Landing Pages',
            createButton: 'Add Landing Page',
            createButtonMobile: 'Add',
            successMessage: 'Link has been Copied',
            errorMessage: 'Link was not created yet'
        },
        tableHeaders: [
            {
                text: 'Created',
                sortable: false
            },
            {
                text: 'Title',
                sortable: false
            },
            { text: 'Actions', sortable: false, class: 'SessionActions' }
        ]
    }
};
